<div class="container">
  @if (blockedUi) {
  <div class="fp-block-ui-overlay" aria-live="polite" aria-busy="true">
    <i class="pi pi-spin pi-spinner" style="font-size: 60px;font-weight: bold"></i>
  </div>
  }

  <div class="grid">
    <div class="col-12">
      <h2 class="page-title">{{'TRANSLATE.MANAGE.CONTRACTS' | translate}}</h2>
    </div>

    <div class="col-12">
      <p-accordion [multiple]="true">
        <p-accordionTab header="{{'TRANSLATE.CLIENT.DATA' | translate}}" [selected]="true">
          <div class="grid ui-fluid">

            <!-- Linha 1: Nome completo (campos largos) -->
            <div class="col-12 md:col-6">
              <label class="filtro" for="customerNameEdit">
                {{'TRANSLATE.TWO.POINTS.NAME' | translate}}
              </label><br />
              <input pInputText id="customerNameEdit" [disabled]="isEditBlockDisabled"
                [(ngModel)]="filterContractSearchResult.customerName" type="text"
                [title]="filterContractSearchResult.customerName || ''" style="width: 100%" />
            </div>

            <div class="col-12 md:col-6">
              <label class="filtro" for="customerLastNameEdit">
                {{'TRANSLATE.TWO.POINTS.LAST.NAME' | translate}}
              </label><br />
              <input pInputText id="customerLastNameEdit" [disabled]="isEditBlockDisabled"
                [(ngModel)]="filterContractSearchResult.customerLastName" type="text"
                [title]="filterContractSearchResult.customerLastName || ''" style="width: 100%" />
            </div>

            <!-- Linha 2: Identificação e contato (3 por linha) -->
            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="customerDocumentEdit">
                {{'TRANSLATE.TWO.POINTS.CPF.CNPJ' | translate }}
              </label><br />
              <input pInputText id="customerDocumentEdit" [disabled]="isEditBlockDisabled"
                [(ngModel)]="filterContractSearchResult.customerDocument" (ngModelChange)="onDocumentInput($event)"
                type="text" [title]="filterContractSearchResult.customerDocument || ''" style="width: 100%" />
            </div>

            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="customerEmailEdit">
                {{ 'TRANSLATE.TWO.POINTS.EMAIL' | translate }}
              </label><br />
              <input id="customerEmailEdit" [disabled]="isEditDisabled" [(ngModel)]="editingCustomerEmail"
                (ngModelChange)="onCustomerEmailInput($event)" type="email" name="email" [email]="validateEmail"
                #prmEmail="ngModel" maxlength="50" style="width: 100%" required pInputText />
              <span class="char-counter">{{ 'TRANSLATE.CLIENT.DATA.CHARACTER.COUNTER' | translate:{ current:
                (editingCustomerEmail?.length || 0), max: 50 } }}</span>
              @if (invalidEmailFormat) {
              <p-message class="client-data-message" severity="error"
                text="{{ 'TRANSLATE.INVALID.EMAIL' | translate }}"></p-message>
              }
              @if (isEditingMode && hasAttemptedSave && requiredCustomerEmail === true) {
              <p-message class="client-data-message" severity="error"
                text="{{ 'TRANSLATE.ENTER.THE.VALUE.OF.THE.FIELD' | translate }}">
              </p-message>
              }
            </div>

            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="customerPhoneEdit">
                {{'TRANSLATE.TWO.POINTS.PHONE' | translate}}
              </label><br />
              <input pInputText id="customerPhoneEdit" [disabled]="isEditBlockDisabled"
                [(ngModel)]="filterContractSearchResult.customerPhone" (ngModelChange)="onPhoneInput($event)"
                type="text" style="width: 100%" />
            </div>

            <!-- Linha 3: CEP / Endereço / Número -->
            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="customerCepEdit">
                {{'TRANSLATE.TWO.POINTS.CEP' | translate }}
              </label><br />
              <input pInputText id="customerCepEdit" [disabled]="isEditBlockDisabled"
                [(ngModel)]="filterContractSearchResult.customerCep" (ngModelChange)="onCepInput($event)" type="text"
                style="width: 100%" />
            </div>

            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="customerAddressEdit">
                {{'TRANSLATE.TWO.POINTS.ADDRESS' | translate }}
              </label><br />
              <input pInputText id="customerAddressEdit" [disabled]="isEditBlockDisabled"
                [(ngModel)]="filterContractSearchResult.customerAddress" type="text" style="width: 100%" />
            </div>

            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="customerAddressNumberEdit">
                {{'TRANSLATE.TWO.POINTS.NUMBER.WRITTEN' | translate }}
              </label><br />
              <input pInputText id="customerAddressNumberEdit" [disabled]="isEditBlockDisabled"
                [(ngModel)]="filterContractSearchResult.customerAddressNumber" type="text" style="width: 100%" />
            </div>

            <!-- Linha 4: Complemento / Bairro / Cidade -->
            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="customerAddressCompEdit">
                {{ 'TRANSLATE.TWO.POINTS.COMPLEMENT' | translate }}
              </label><br />
              <input pInputText id="customerAddressCompEdit" [disabled]="isEditBlockDisabled"
                [(ngModel)]="filterContractSearchResult.customerAddressComp" type="text" style="width: 100%" />
            </div>

            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="customerAddressDistrictEdit">
                {{'TRANSLATE.TWO.POINTS.SURROUND' | translate}}
              </label><br />
              <input pInputText id="customerAddressDistrictEdit" [disabled]="isEditBlockDisabled"
                [(ngModel)]="filterContractSearchResult.customerAddressDistrict" type="text" style="width: 100%" />
            </div>

            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="customerAddressCityEdit">
                {{'TRANSLATE.TWO.POINTS.CITY' | translate}}
              </label><br />
              <input pInputText id="customerAddressCityEdit" [disabled]="isEditBlockDisabled"
                [(ngModel)]="filterContractSearchResult.customerAddressCity" type="text" style="width: 100%" />
            </div>

            <!-- Linha 5: Estado -->
            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="customerAddressStateEdit">
                {{'TRANSLATE.TWO.POINTS.STATE' | translate}}
              </label><br />
              <input pInputText id="customerAddressStateEdit" [disabled]="isEditBlockDisabled"
                [(ngModel)]="filterContractSearchResult.customerAddressState" type="text" style="width: 100%" />
            </div>

          </div>
        </p-accordionTab>

        <p-accordionTab header="{{'TRANSLATE.DEALERSHIP.DATA' | translate}}" [selected]="true">
          <div class="grid ui-fluid">
            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="dnPacEdit">{{ 'TRANSLATE.TWO.POINTS.CODE' | translate
                }}</label><br />
              <input pInputText id="dnPacEdit" [disabled]="isEditBlockDisabled"
                [(ngModel)]="filterContractSearchResult.dnPac" type="text" style="width: 100%" />
            </div>

            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="dnNameEdit">{{'TRANSLATE.TWO.POINTS.NAME' |
                translate}}</label><br />
              <input pInputText id="dnNameEdit" [disabled]="isEditBlockDisabled"
                [(ngModel)]="filterContractSearchResult.dnName" type="text" style="width: 100%" />
            </div>

            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="dnEmailEdit">{{ 'TRANSLATE.TWO.POINTS.EMAIL' | translate
                }}</label><br />
              <input pInputText id="dnEmailEdit" [disabled]="isEditBlockDisabled"
                [(ngModel)]="filterContractSearchResult.dnEmail" type="text" style="width: 100%" />
            </div>

            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="dnPhoneEdit">{{'TRANSLATE.TWO.POINTS.PHONE' |
                translate}}</label><br />
              <input pInputText id="dnPhoneEdit" [disabled]="isEditBlockDisabled"
                [(ngModel)]="filterContractSearchResult.dnPhone" (ngModelChange)="onDealerPhoneInput($event)"
                type="text" style="width: 100%" />
            </div>

            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="dnCityEdit">{{ 'TRANSLATE.TWO.POINTS.CITY' | translate
                }}</label><br />
              <input pInputText id="dnCityEdit" [disabled]="isEditBlockDisabled"
                [(ngModel)]="filterContractSearchResult.dnCity" type="text" style="width: 100%" />
            </div>

            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="sellerCodeEdit">{{ 'TRANSLATE.TWO.POINTS.SELLER.CODE' | translate
                }}</label><br />
              <input pInputText id="sellerCodeEdit" [disabled]="isEditBlockDisabled"
                [(ngModel)]="filterContractSearchResult.sellerCode" type="text" style="width: 100%" />
            </div>

            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="sellerNameEdit">{{ 'TRANSLATE.TWO.POINTS.SALESMAN.NAME' |
                translate }}</label><br />
              <input pInputText id="sellerNameEdit" [disabled]="isEditBlockDisabled"
                [(ngModel)]="filterContractSearchResult.sellerName" type="text" style="width: 100%" />
            </div>

            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="sellerEmailEdit">{{ 'TRANSLATE.TWO.POINTS.SALESMAN.EMAIL' |
                translate }}</label><br />
              <input pInputText id="sellerEmailEdit" [disabled]="isEditBlockDisabled"
                [(ngModel)]="filterContractSearchResult.sellerEmail" type="text" style="width: 100%" />
            </div>

            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="sellerPhoneEdit">{{ 'TRANSLATE.TWO.POINTS.SALESMAN.PHONE' |
                translate }}</label><br />
              <input pInputText id="sellerPhoneEdit" [disabled]="isEditBlockDisabled"
                [(ngModel)]="filterContractSearchResult.sellerPhone" (ngModelChange)="onSellerPhoneInput($event)"
                type="text" style="width: 100%" />
            </div>
          </div>
        </p-accordionTab>

        <p-accordionTab header="{{ 'TRANSLATE.CONTRACT.DATA' | translate }}" [selected]="true">
          <div class="grid ui-fluid">
            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="contractNumberEdit">
                {{ 'TRANSLATE.TWO.POINTS.ORIGINAL.CONTRACT.NUMBER' | translate }}
              </label><br />
              <input pInputText id="contractNumberEdit" [disabled]="isEditBlockDisabled"
                [(ngModel)]="filterContractSearchResult.contractNumber" type="text" style="width: 100%" />
            </div>
            <!--
                                                        <div class="col-12 md:col-6 lg:col-4">
                                                          <label class="filtro" for="contractCodeFp2Edit">Número Contrato FP2:</label><br/>
                                                          <input pInputText id="contractCodeFp2Edit" [disabled]="isEditBlockDisabled"  [(ngModel)]="filterContractSearchResult.contractCodeFp2" type="text" style="width: 100%"/>
                                                        </div>
                                                        -->
            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="countryEdit">{{ 'TRANSLATE.TWO.POINTS.COUNTRY' | translate
                }}</label><br />
              <input pInputText id="countryEdit" [disabled]="isEditBlockDisabled"
                [(ngModel)]="filterContractSearchResult.country" type="text" style="width: 100%" />
            </div>

            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="contractStatusEdit">{{ 'TRANSLATE.TWO.POINTS.CONTRACT.STATUS' |
                translate }}</label><br />
              <p-dropdown id="contractStatusEdit" [disabled]="isEditBlockDisabled"
                placeholder="{{ 'TRANSLATE.SELECT' | translate }}"
                [(ngModel)]="filterContractSearchResult.contractStatusCode" [options]="statusContract"
                [style]="{'minWidth':'100%'}">
                <ng-template pTemplate="item" let-item>
                  {{item?.label | translate}}
                </ng-template>
                <ng-template pTemplate="selectedItem" let-item>
                  {{ item?.label ? (item.label | translate) : ('TRANSLATE.SELECT' | translate) }}
                </ng-template>
              </p-dropdown>
            </div>

            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="vinStatusEdit">{{ 'TRANSLATE.TWO.POINTS.CHASSIS.STATUS' |
                translate }}</label><br />
              <p-dropdown id="vinStatusEdit" [disabled]="isEditBlockDisabled"
                placeholder="{{ 'TRANSLATE.SELECT' | translate }}"
                [(ngModel)]="filterContractSearchResult.vinStatusCode" [options]="statusContract"
                [style]="{'minWidth':'100%'}">
                <ng-template pTemplate="item" let-item>
                  {{item?.label | translate}}
                </ng-template>
                <ng-template pTemplate="selectedItem" let-item>
                  {{ item?.label ? (item.label | translate) : ('TRANSLATE.SELECT' | translate) }}
                </ng-template>
              </p-dropdown>
            </div>
            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="saleTypeEdit">{{'TRANSLATE.TWO.POINTS.SALE.TYPE' |
                translate}}</label><br />
              <input pInputText id="saleTypeEdit" [disabled]="isEditBlockDisabled" [(ngModel)]="salesTypeFord"
                type="text" style="width: 100%" />
            </div>

            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="vinEdit">{{'TRANSLATE.TWO.POINTS.CHASSIS' |
                translate}}</label><br />
              <input pInputText id="vinEdit" [disabled]="isEditBlockDisabled"
                [(ngModel)]="filterContractSearchResult.vin" type="text" style="width: 100%" />
            </div>

            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="wsdEdit">{{'TRANSLATE.TWO.POINTS.WARRANTY.START.DATE' |
                translate}}</label><br />
              <p-calendar id="wsdEdit" [readonlyInput]="true" [disabled]="isEditBlockDisabled"
                [(ngModel)]="filterContractSearchResult.wsd" dateFormat="dd/mm/yy" [style]="{'width':'100%'}"
                [inputStyle]="{'width':'100%'}"></p-calendar>
            </div>

            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="saleDateEdit">
                {{'TRANSLATE.TWO.POINTS.SALE.DATE' | translate}}
              </label><br />
              <p-calendar id="saleDateEdit" [readonlyInput]="true" [disabled]="isEditBlockDisabled"
                [(ngModel)]="filterContractSearchResult.vinSaleDate" dateFormat="dd/mm/yy" [style]="{'width':'100%'}"
                [inputStyle]="{'width':'100%'}"></p-calendar>
            </div>

            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="vinStartDateEdit">
                {{ 'TRANSLATE.TWO.POINTS.START.DATE.OF.CHASSIS.IN.CONTRACT' | translate }}
              </label><br />
              <p-calendar id="vinStartDateEdit" [readonlyInput]="true" [disabled]="isEditBlockDisabled"
                [(ngModel)]="filterContractSearchResult.vinStartDate" dateFormat="dd/mm/yy" [style]="{'width':'100%'}"
                [inputStyle]="{'width':'100%'}"></p-calendar>
            </div>

            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="vinEndDateEdit">
                {{'TRANSLATE.TWO.POINTS.END.DATE.OF.CHASSIS.IN.CONTRACT' | translate}}
              </label><br />
              <p-calendar id="vinEndDateEdit" [readonlyInput]="true" [disabled]="isEditBlockDisabled"
                [(ngModel)]="filterContractSearchResult.vinEndDate" dateFormat="dd/mm/yy" [style]="{'width':'100%'}"
                [inputStyle]="{'width':'100%'}"></p-calendar>
            </div>

            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="coverageStartDateEdit">
                {{'TRANSLATE.TWO.POINTS.COVERAGE.START.DATE' | translate }}
              </label><br />
              <p-calendar id="coverageStartDateEdit" [readonlyInput]="true" [disabled]="isEditBlockDisabled"
                [(ngModel)]="filterContractSearchResult.coverageStartDate" dateFormat="dd/mm/yy"
                [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}"></p-calendar>
            </div>

            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="coverageEndDateEdit">
                {{'TRANSLATE.TWO.POINTS.COVERAGE.END.DATE' | translate}}
              </label><br />
              <p-calendar id="coverageEndDateEdit" [readonlyInput]="true" [disabled]="isEditBlockDisabled"
                [(ngModel)]="filterContractSearchResult.coverageEndDate" [ngModelOptions]="{standalone: true}"
                dateFormat="dd/mm/yy" [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}"></p-calendar>
            </div>

            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="vinActualEndDateEdit">
                {{'TRANSLATE.TWO.POINTS.CHASSIS.CLOSING.DATE' | translate}}
              </label><br />
              <p-calendar id="vinActualEndDateEdit" [disabled]="isEditBlockDisabled"
                [(ngModel)]="filterContractSearchResult.vinActualEndDate" dateFormat="dd/mm/yy"
                [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}"></p-calendar>
            </div>

            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="cancellationRequestDateEdit">
                {{ 'TRANSLATE.DATE.OF.CANCELLATION.REQUEST' | translate }}
              </label><br />
              <p-calendar id="cancellationRequestDateEdit" [disabled]="isEditBlockDisabled"
                [(ngModel)]="filterContractSearchResult.cancellationRequestDate" dateFormat="dd/mm/yy"
                [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}"></p-calendar>
            </div>

            <!--
                                                              <div class="col-12 md:col-6 lg:col-4">
                                                                <label class="filtro" for="productCodeEdit">Código do Produto:</label><br/>
                                                                <input id="productCodeEdit" pInputText [disabled]="isEditBlockDisabled" [(ngModel)]="filterContractSearchResult.productCode" type="text" style="width: 100%"/>
                                                              </div>

                                                              <div class="col-12 md:col-6 lg:col-4">
                                                                <label class="filtro" for="productOriginalNameEdit">Nome do Plano Original:</label><br/>
                                                                <input id="productOriginalNameEdit" pInputText [disabled]="isEditBlockDisabled" [(ngModel)]="filterContractSearchResult.productOriginalName" type="text" style="width: 100%"/>
                                                              </div>
                                                              -->
            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="productNameEdit">{{'TRANSLATE.TWO.POINTS.PRODUCT.NAME' |
                translate}}</label><br />
              <input id="productNameEdit" pInputText [disabled]="isEditBlockDisabled"
                [(ngModel)]="filterContractSearchResult.productName" type="text" style="width: 100%" />
            </div>

            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="contractFinalPriceEdit">
                {{'TRANSLATE.TWO.POINTS.FINAL.CHASSIS.PRICE' | translate}}
              </label><br />
              <input id="contractFinalPriceEdit" pInputText [disabled]="isEditBlockDisabled"
                [(ngModel)]="filterContractSearchResult.contractFinalPrice" type="text" style="width: 100%" />
            </div>

            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="vinSellerPriceEdit">
                {{'TRANSLATE.TWO.POINTS.FINAL.SALESMAN.PRICE' | translate}}
              </label><br />
              <input id="vinSellerPriceEdit" pInputText [disabled]="isEditBlockDisabled"
                [(ngModel)]="filterContractSearchResult.vinSellerPrice" type="text" style="width: 100%" />
            </div>

            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="vinCustomerPriceEdit">
                {{'TRANSLATE.TWO.POINTS.FINAL.CLIENT.PRICE' | translate }}
              </label><br />
              <input id="vinCustomerPriceEdit" pInputText [disabled]="isEditBlockDisabled"
                [(ngModel)]="filterContractSearchResult.vinCustomerPrice" type="text" style="width: 100%" />
            </div>

            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="refundsForCustomersEdit">
                {{ 'TRANSLATE.REFOUNDS' | translate }}
              </label><br />
              <input id="refundsForCustomersEdit" pInputText [disabled]="isEditBlockDisabled"
                [(ngModel)]="filterContractSearchResult.refundsForCustomers" type="text" style="width: 100%" />
            </div>

            <!--
                                                                        <div class="col-12 md:col-6 lg:col-4">
                                                                          <label class="filtro" for="coverageCategoryEdit">Categoria da Cobertura:</label><br/>
                                                                          <input id="coverageCategoryEdit" pInputText [disabled]="isEditBlockDisabled" [(ngModel)]="filterContractSearchResult.coverageCategory" type="text" style="width: 100%"/>
                                                                        </div>

                                                                        <div class="col-12 md:col-6 lg:col-4">
                                                                          <label class="filtro" for="coverageCodeEdit">Código Cobertura:</label><br/>
                                                                          <input id="coverageCodeEdit" pInputText [disabled]="isEditBlockDisabled" [(ngModel)]="filterContractSearchResult.coverageCode" type="text" style="width: 100%"/>
                                                                        </div>
                                                                        -->
            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="coverageDescriptionEdit">
                {{ 'TRANSLATE.TWO.POINTS.COVERAGE.DESCRIPTION' | translate }}
              </label><br />
              <input id="coverageDescriptionEdit" pInputText [disabled]="isEditBlockDisabled"
                [(ngModel)]="filterContractSearchResult.coverageDescription" type="text" style="width: 100%" />
            </div>

            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="coverageNameEdit">
                {{ 'TRANSLATE.TWO.POINTS.COVERAGE.NAME' | translate }}
              </label><br />
              <input id="coverageNameEdit" pInputText [disabled]="isEditBlockDisabled"
                [(ngModel)]="filterContractSearchResult.coverageName" type="text" style="width: 100%" />
            </div>

            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="coverageMonthsEdit">
                {{'TRANSLATE.TWO.POINTS.COVERAGE.MONTHS' | translate }}
              </label><br />
              <input id="coverageMonthsEdit" pInputText [disabled]="isEditBlockDisabled"
                [(ngModel)]="filterContractSearchResult.coverageMonths" type="text" style="width: 100%" />
            </div>

            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="coverageKmEdit">
                {{'TRANSLATE.TWO.POINTS.COVERAGE.KILOMETERS' | translate }}
              </label><br />
              <p-inputNumber id="coverageKmEdit" [disabled]="isEditBlockDisabled"
                [(ngModel)]="filterContractSearchResult.coverageKm" mode="decimal" inputId="withoutgrouping"
                [useGrouping]="false" maxlength="12"
                [style]="{'width':'100%','height':'32px','font-size':'16px'}"></p-inputNumber>
            </div>
            <!--
                                                                              <div class="col-12 md:col-6 lg:col-4">
                                                                                <label class="filtro" for="coverageStartVisitEdit">Visita Inicial do Contador:</label><br/>
                                                                                <input id="coverageStartVisitEdit" pInputText [disabled]="isEditBlockDisabled" [(ngModel)]="filterContractSearchResult.coverageStartVisit" type="text" style="width: 100%"/>
                                                                              </div>
                                                                              -->
            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="coverageVisitLimitEdit">
                {{ 'TRANSLATE.TWO.POINTS.VISIT.LIMIT' | translate }}
              </label><br />
              <input id="coverageVisitLimitEdit" pInputText [disabled]="isEditBlockDisabled"
                [(ngModel)]="filterContractSearchResult.coverageVisitLimit" type="text" maxlength="2"
                (keydown)="restrictCoverageVisitLimitKeypress($event)" style="width: 100%" />
            </div>
            <!--
                                                                                <div class="col-12 md:col-6 lg:col-4">
                                                                                  <label class="filtro" for="coverageVisitCounterEdit">Contador de Visitas:</label><br/>
                                                                                  <p-inputNumber id="coverageVisitCounterEdit" [disabled]="isEditDisabled" [(ngModel)]="filterContractSearchResult.coverageVisitCounter" mode="decimal" inputId="withoutgrouping" [useGrouping]="false"
                                                                                  maxlength="12" [style]="{'width':'100%','height':'32px','font-size':'16px'}"></p-inputNumber>
                                                                                </div>
                                                                                -->
          </div>
        </p-accordionTab>

        @if (userCountry === 'BRA') {
        <p-accordionTab header="{{'TRANSLATE.DATA.PAYMENT' | translate}}" [selected]="true">
          <div class="grid ui-fluid">
            <div class="col-12 md:col-6 lg:col-4">
              <span class="filtro">
                {{'TRANSLATE.TWO.POINTS.RESEND.EMAIL.FOR.PAYMENT' | translate}}
              </span><br />
              <button pButton class="resend-payment-link-button" [disabled]="isButtonEnviarLinkDisabled || isSubmitted"
                [attr.aria-busy]="isSubmitted" [icon]="isSubmitted ? 'pi pi-spin pi-spinner' : ''" type="button"
                (click)="buttonSendEmail()">
                {{ (isSubmitted ? 'TRANSLATE.SENDING.EMAIL' : 'TRANSLATE.BTN.SUBMIT') | translate }}
              </button>
            </div>
            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="expirationDateLinkEdit">
                {{'TRANSLATE.TWO.POINTS.LINK.EXPIRATION.DATE' | translate }}
              </label><br />
              <p-calendar id="expirationDateLinkEdit" [readonlyInput]="true" [disabled]="isEditBlockDisabled"
                [(ngModel)]="filterContractSearchResult.dateExpirationLink" dateFormat="dd/mm/yy"
                [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}"></p-calendar>
            </div>
            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="paymentMethodEdit">
                {{'TRANSLATE.TWO.POINTS.FORM.OF.PAYMENT' | translate}}
              </label><br />
              <input id="paymentMethodEdit" pInputText [disabled]="isEditBlockDisabled"
                [(ngModel)]="filterContractSearchResult.paymentMethod" type="text" style="width: 100%" />
            </div>
            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="paymentParcelsEdit">{{'TRANSLATE.TWO.POINTS.INSTALLMENT' |
                translate}}</label><br />
              <input id="paymentParcelsEdit" pInputText [disabled]="isEditBlockDisabled"
                [(ngModel)]="filterContractSearchResult.paymentParcels" type="text" style="width: 100%" />
            </div>
            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="contractValueEdit">
                {{ 'TRANSLATE.TWO.POINTS.CONTRACT.VALUE' | translate }}
              </label><br />
              <input id="contractValueEdit" pInputText [disabled]="isEditBlockDisabled"
                [(ngModel)]="filterContractSearchResult.contractValue" type="text" style="width: 100%" />
            </div>
            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="parcelValueEdit">
                {{ 'TRANSLATE.TWO.POINTS.APPROXIMATE.PORTION.VALUE' | translate }}
              </label><br />
              <input id="parcelValueEdit" pInputText [disabled]="isEditBlockDisabled"
                [(ngModel)]="filterContractSearchResult.parcelValue" type="text" style="width: 100%" />
            </div>
          </div>
        </p-accordionTab>
        }

        @if (systemCountry === 'BRA' && canceledContractInformation) {
        <p-accordionTab header="{{ 'TRANSLATE.CANCELLATION.REQUEST.DATA' | translate }}" [selected]="true">
          <div class="grid ui-fluid">
            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="cancellationDateEdit">
                {{ 'TRANSLATE.CANCELLATION.DATE' | translate }}
              </label><br />
              <p-calendar id="cancellationDateEdit" [disabled]="isEditBlockDisabled" [(ngModel)]="cancellationDate"
                dateFormat="dd/mm/yy" [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}"></p-calendar>
            </div>
            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="incurredMonthsEdit">{{ 'TRANSLATE.MONTHS.ELAPSED' | translate
                }}</label><br />
              <input id="incurredMonthsEdit" pInputText [disabled]="isEditBlockDisabled"
                [(ngModel)]="canceledContractInformation.incurredMonths" type="text" style="width: 100%" />
            </div>
            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="informedKmEdit">
                {{ 'TRANSLATE.KM.INFORMED' | translate }}
              </label><br />
              <p-inputNumber id="informedKmEdit" [disabled]="isEditBlockDisabled"
                [(ngModel)]="canceledContractInformation.informedKm" mode="decimal" inputId="informedKm"
                [useGrouping]="true" [maxFractionDigits]="0" [locale]="'pt-BR'" maxlength="12"
                [style]="{'width':'100%','height':'32px','font-size':'16px'}">
              </p-inputNumber>
            </div>
            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="indexIPCAEdit">
                {{ 'TRANSLATE.IPCA.RATE' | translate }}
              </label><br />
              <input id="indexIPCAEdit" pInputText [disabled]="isEditBlockDisabled"
                [(ngModel)]="canceledContractInformation.indexTax" type="text" style="width: 100%" />
            </div>
            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="adminTaxEdit">
                {{ 'TRANSLATE.ADMINISTRATIVE.FREE' | translate }}
              </label><br />
              <input id="adminTaxEdit" pInputText [disabled]="isEditBlockDisabled"
                [(ngModel)]="canceledContractInformation.adminTax" type="text" style="width: 100%" />
            </div>
            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="finalPriceReturnEdit">
                {{ 'TRANSLATE.FINAL.PRICE.RETURN' | translate }}
              </label><br />
              <p-inputNumber id="finalPriceReturnEdit" [disabled]="isEditBlockDisabled"
                [(ngModel)]="cancelledTotalValueEdit" mode="decimal" [currency]="undefined" [locale]="'pt-BR'"
                [minFractionDigits]="2" [maxFractionDigits]="2" [useGrouping]="true"
                [style]="{'width':'100%','height':'32px','font-size':'16px'}">
              </p-inputNumber>
            </div>
            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="fordPriceReturnEdit">
                {{ 'TRANSLATE.FORD.PRICE.RETURN' | translate }}
              </label><br />
              <p-inputNumber id="fordPriceReturnEdit" [disabled]="isEditBlockDisabled"
                [(ngModel)]="cancelledFordValueEdit" mode="decimal" [currency]="undefined" [locale]="'pt-BR'"
                [minFractionDigits]="2" [maxFractionDigits]="2" [useGrouping]="true"
                [style]="{'width':'100%','height':'32px','font-size':'16px'}">
              </p-inputNumber>
            </div>
            <div class="col-12 md:col-6 lg:col-4">
              <label class="filtro" for="dealerPriceReturnEdit">
                {{ 'TRANSLATE.DEALER.PRICE.RETURN' | translate }}
              </label><br />
              <p-inputNumber id="dealerPriceReturnEdit" [disabled]="isEditBlockDisabled"
                [(ngModel)]="cancelledDealerValueEdit" mode="decimal" [currency]="undefined" [locale]="'pt-BR'"
                [minFractionDigits]="2" [maxFractionDigits]="2" [useGrouping]="true"
                [style]="{'width':'100%','height':'32px','font-size':'16px'}">
              </p-inputNumber>
            </div>
          </div>
        </p-accordionTab>
        }

        <p-accordionTab header="{{'TRANSLATE.CONTRACT.NOTES' | translate }}" [selected]="true">

          <div class="grid ui-fluid">

            <div class="col-12 md:col-12 lg:col-12">
              <textarea id="contractNotesEdit" pInputTextarea [disabled]="isEditDisabled"
                [(ngModel)]="editingContractRemarks" (ngModelChange)="onContractNotesInput($event)" rows="5"
                maxlength="500" autoResize="false" style="width: 100%" (keyup)="textAreaCounterCaracteres()"></textarea>

              <div class="char-counter">
                {{ countCaracteresTextArea }} {{ 'TRANSLATE.MAX.CHARACTERS.500' | translate }}
              </div>
            </div>

            @if (isEditingMode && hasAttemptedSave && requiredContractNotes === true) {
            <p-message class="client-data-message" severity="error"
              text="{{ 'TRANSLATE.ENTER.THE.VALUE.OF.THE.FIELD' | translate }}">
            </p-message>
            }
          </div>
        </p-accordionTab>

      </p-accordion>
    </div>

    <div class="col-12 contract-edit-actions">
      @if (!isEditingMode && isEditActionDisabledByCancellationState && editDisabledReasonKey) {
      <p-message class="contract-edit-disabled-reason" severity="warn" icon="pi pi-exclamation-triangle"
        [text]="(editDisabledReasonKey | translate)">
      </p-message>
      }
      @if (!isEditingMode) {
      <button pButton class="app-clean-button" (click)="buttonComeBack()" type="button" icon="pi pi-arrow-left"
        [disabled]="isSubmitted">
        {{ 'TRANSLATE.RETURN' | translate }}
      </button>
      }
      @if (!isEditingMode) {
      <button pButton class="app-filter-button"
        [disabled]="isPermissionButtonEditDisabled || isSubmitted || isEditActionDisabledByCancellationState"
        (click)="buttonEditEnabled()" icon="pi pi-pencil" type="button">
        {{'TRANSLATE.EDIT' | translate }}
      </button>
      }
      @if (isEditingMode) {
      <button pButton class="app-clean-button" [disabled]="isSubmitted" icon="pi pi-times" type="button"
        (click)="buttonEditDisabled()">
        {{ 'TRANSLATE.CANCEL' | translate }}
      </button>
      }
      @if (isEditingMode) {
      <button pButton class="app-filter-button" [disabled]="isButtonSaveDisabled || isSubmitted"
        [attr.aria-busy]="isSubmitted" [icon]="isSubmitted ? 'pi pi-spin pi-spinner' : 'pi pi-check'" type="button"
        (click)="buttonSaveEdit()">
        {{ (isSubmitted ? 'TRANSLATE.SAVING' : 'TRANSLATE.SAVE') | translate }}
      </button>
      }
    </div>
  </div>
</div>